export default __webpack_public_path__ + "static/screenshot-actions--mobile-eac6f0d97c45aa80b650b001445b7e85.webp";